import { StyledEngineProvider } from '@mui/material/styles'
import { ThemeProvider } from '@mui/material/styles'
import { useOutletContext, useParams, useNavigate } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import theme from '../theme'
import classes from './InvaderPage.module.css'
import 'animate.css'

const InvaderPage = () => {
  let autoDiv = []
  let checkTrulyCellInTheGrid
  const context = useOutletContext()
  const params = useParams()

  const navigate = useNavigate()
  function navigateHandler() {
    navigate('/')
  }

  // put together results of getShape and getColor
  function getTotalGrid(shape, color) {
    for (var j = 0; j < shape.length; j++) {
      checkTrulyCellInTheGrid = shape[j] === true
      autoDiv.push(
        <div
          className={
            classes.divBox + ' ' + checkTrulyCellInTheGrid + ' ' + color[j]
          }
          key={j}
        ></div>,
      )
    }
    return autoDiv
  }

  let res = params.id.replace(/\D/g, '')
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <div className={classes.container}>
          <div className={classes.midContainer}>
            <IconButton
              onClick={navigateHandler}
              className={classes.backButton}
              color="primary"
              aria-label="upload picture"
              component="label"
            >
              <ArrowBackIcon />
            </IconButton>

            {context.name.map((x, index) => {
              if (parseInt(res) === index + 1) {
                return (
                  <div className={classes.semiInnerContainer} key={index}>
                    <div className={classes.innerContainer}>
                      {getTotalGrid(x.shape, x.color)}
                    </div>
                    <div>
                      <div className={classes.containerTexts}>
                        <div className={classes.leftText}>Name</div>
                        <div className={classes.separator}></div>
                        {x.name === '' ? (
                          <div
                            className={`${classes.rightText} ${classes.notSpecText}`}
                          >
                            not specified
                          </div>
                        ) : (
                          <div className={classes.rightText}>{x.name}</div>
                        )}
                      </div>

                      <div className={classes.containerTexts}>
                        <div className={classes.leftText}>Creation date</div>
                        <div className={classes.separator}></div>
                        <div className={classes.rightText}>{x.date}</div>
                      </div>

                      <div className={classes.containerTexts}>
                        <div className={classes.leftText}>Number ID</div>
                        <div className={classes.separator}></div>
                        <div className={classes.rightText}>{index + 1}</div>
                      </div>

                      <div className={classes.containerTexts}>
                        <div className={classes.leftText}>Color set</div>
                        <div className={classes.separator}></div>
                        <div className={classes.rightText}>{x.colorSet}</div>
                      </div>
                    </div>
                  </div>
                )
              }
            })}
          </div>
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default InvaderPage
